import React from 'react'

import { useProductImage } from './hooks'
import { ProductImage } from '@/checkout-instore-legacy/components/Product'

export type ResizedProductImageProps = {
  src?: string
  alt: string
  sizeInPx: number
} & React.ComponentProps<'div'>

export const ResizedProductImage = ({
  src: initialSrc,
  sizeInPx,
  ...props
}: ResizedProductImageProps) => {
  const { handleImageError, src } = useProductImage({
    src: initialSrc,
    sizeInPx,
  })

  return (
    <ProductImage src={src} onLoadImageError={handleImageError} {...props} />
  )
}
